import React from 'react';
import './App.css';

const Header = () => {
    return (
        <header className="header">
            <h1>Dark Weather</h1>
            <p>Seeing the weather of the whole world with <strong>Dark Weather!</strong></p>
        </header>
    );
};

export default Header;
